export default __webpack_public_path__ + "static/media/fontLato900_latin.49bb7a63.woff2";